import http from "../http-common";

class ExaminerRemarkService {
  createExaminerRemark(data) {
      return http.post(`/api/examiner_remark`, data);
    }
  getExaminerRemarks() {
    return http.get(`/api/examiner_remark`);
  }
  getExaminerRemark(id) {
    return http.get(`/api/examiner_remark/`+id);
  }
  updateExaminerRemark(id, data) {
    return http.put(`/api/examiner_remark/${id}`, data);
  }
}

export default new ExaminerRemarkService();